import { useTranslation } from "react-i18next";
import careseeker from "../../../assets/png/careseeker.png";
import confianceImage from "../../../assets/png/confiance.png";
import homecare from "../../../assets/png/homecare.png";
import styles from "./VMVValeurs.module.scss";

function VMVValeurs() {
  const { t } = useTranslation();

  const valeursList: {
    image: string;
    text: string;
  }[] = [
      {
        image: confianceImage,
        text: t("vmvValeurs.values.confidence"),
      },
      {
        image: homecare,
        text: t("vmvValeurs.values.homecare"),
      },
      {
        image: careseeker,
        text: t("vmvValeurs.values.cohesion"),
      },
    ];
  return (
    <article className={styles.vmvValeurs}>
      <h1>{t("vmvValeurs.title")}</h1>
      <article className={styles.vmvValeurs__valeurs}>
        {valeursList.map((valeur, index) => {
          return (
            <section
              key={`VMV_valeur_${index}`}
              className={styles.vmvValeurs__valeurs__item}
            >
              <figure
                style={{ backgroundImage: `url(${valeur.image})` }}
              ></figure>
              <p>{valeur.text}</p>
            </section>
          );
        })}
      </article>
    </article>
  );
}

export default VMVValeurs;
